/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, OnInit } from '@angular/core';
import { takeUntil, map } from 'rxjs/operators';
import { NbThemeService } from '@nebular/theme';
import { UserStore } from '../../../@core/stores/user.store';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Powered by <b>
      <a href="https://exine.com" target="_blank">Exine Technology</a></b> {{ currentYear }}</span>
      <div *ngIf="displayMediaSize">
        <span class="badge badge-warning d-inline-block d-sm-none">XS</span>
        <span class="badge badge-warning d-none d-sm-inline-block d-md-none">SM</span>
        <span class="badge badge-warning d-none d-md-inline-block d-lg-none">MD</span>
        <span class="badge badge-warning d-none d-lg-inline-block d-xl-none">LG</span>
        <span class="badge badge-warning d-none d-xl-inline-block d-xxl-none">XL</span>
        <span class="badge badge-warning d-none d-xxl-inline-block d-xxxl-none">XXL</span>
        <span class="badge badge-warning d-none d-xxxl-inline-block">XXXL</span>
      </div>
      `,
      // <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    //   <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    // </nb-select>
})
export class FooterComponent implements OnInit{
  constructor(
    private themeService: NbThemeService,
    private userStore: UserStore) {
}
  private destroy$: Subject<void> = new Subject<void>();
  displayMediaSize = !environment.production;
  currentTheme = 'corporate';
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  get currentYear(): number {
    return new Date().getFullYear();
  }
  ngOnInit(): void {
    this.currentTheme = this.themeService.currentTheme;
    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }
  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
    this.themeService.changeTheme(themeName);
  }
}
